<mat-card class="dialog-card iot-platform-ui-filter-engine_manage-favorite-filters-popup" fxLayout="column">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar" color="accent" fxLayout="row" fxLayoutAlign="space-between center">
      <h1
        class="dialog-card-title iot-platform-ui-filter-engine_manage-favorite-filters-popup__title">{{ 'FILTER_ENGINE.MANAGE_FAVORITE_FILTERS.TITLE' | translate }}</h1>
      <button (click)="close()"
              class="regular-round-button iot-platform-ui-filter-engine_manage-favorite-filters-popup__close-button"
              mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>
  <mat-card-content class="dialog-card-content iot-platform-ui-filter-engine_manage-favorite-filters-popup__content"
                    fxLayout="column">
    <form [formGroup]="manageFavoriteFiltersForm" class="p-4" fxLayout="column" fxLayoutGap="20px">
      <div class="iot-platform-ui-filter-engine_manage-favorite-filters-popup__filter-count"
           fxLayoutAlign="start center" fxLayoutGap="10px">
        <mat-icon>star_outlined</mat-icon>
        <span>{{
            'FILTER_ENGINE.MANAGE_FAVORITE_FILTERS.FILTER_COUNT'
              | translate
              : {
                currentTotal: favoriteFiltersTotal(),
                max: favoriteFiltersMaximumPossible()
              }
          }}</span>
        @if (favoriteFiltersControl.hasError('favoriteFiltersEmpty')) {
          <span class="iot-platform-ui-filter-engine_manage-favorite-filters-popup__no-filter-error" fxFlex>{{
              'FILTER_ENGINE.MANAGE_FAVORITE_FILTERS.ERROR_MESSAGES.NO_FILTER_SELECTED' | translate
            }}</span>
        }
      </div>
      <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="40px">
        @for (category of data.categories; track category.key) {
          <section fxLayout="column" fxLayoutGap="10px">
            <div
              class="iot-platform-ui-filter-engine_manage-favorite-filters-popup__filter-concept-label">{{ category.label | translate }}
            </div>
            <div class="iot-platform-ui-filter-engine_manage-favorite-filters-popup__filter-checkbox-container">
              @for (field of category.fields; track field.key) {
                <mat-checkbox
                  (change)="onFilterSelectionChange($event, category, field)"
                  [checked]="isFavoriteFilter(field, category.key)"
                  [disabled]="isFieldDisabled(field, category.key)"
                  [value]="field.key"
                >{{ field.label | translate }}
                </mat-checkbox>
              }
            </div>
          </section>
        }
      </div>
      <div class="iot-platform-ui-filter-engine_manage-favorite-filters-popup__drag-and-drop-container"
           fxLayout="column" fxLayoutGap="6px">
        <span>{{ 'FILTER_ENGINE.MANAGE_FAVORITE_FILTERS.DRAG_AND_DROP' | translate }}</span>

        <mat-chip-set class="iot-platform-ui-filter-engine_manage-favorite-filters-popup__chip-set"
                      (cdkDropListDropped)="drop($event)" cdkDropList
                      cdkDropListOrientation="horizontal" fxLayout="row wrap"
                      fxLayoutAlign="start center">
          @for (favoriteFilter of favoriteFiltersForOrdering(); track favoriteFilter.name) {
            <mat-chip
              class="iot-platform-ui-filter-engine_manage-favorite-filters-popup__chip mr-1"
              cdkDrag
            >
              <mat-icon class="iot-platform-ui-filter-engine__icon-type iot-platform-ui-filter-engine_manage-favorite-filters-popup__chip-icon mr-1">
                drag_indicator
              </mat-icon>
              <mat-icon class="iot-platform-ui-filter-engine__icon-type iot-platform-ui-filter-engine_manage-favorite-filters-popup__chip-icon mr-1">
                @if (getIsFieldOfTypeList(favoriteFilter)) {
                  format_list_bulleted
                } @else {
                  text_fields
                }
              </mat-icon>
              <span>{{ favoriteFilter.label | translate }} </span>
            </mat-chip>
          }
        </mat-chip-set>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions class="dialog-card-actions" fxLayoutAlign="end center">
    <button (click)="close()" class="button-regular" mat-button>{{ 'IOT_DICTIONARY.CANCEL' | translate }}</button>
    <button (click)="resetToAppDefault()"
            class="button-regular iot-platform-ui-filter-engine_manage-favorite-filters-popup__reset-button"
            color="accent" mat-button>
      {{ 'FILTER_ENGINE.MANAGE_FAVORITE_FILTERS.RESET_TO_APP_DEFAULT' | translate }}
    </button>
    <button
      (click)="save()"
      [disabled]="!manageFavoriteFiltersForm.valid || !manageFavoriteFiltersForm.dirty"
      class="button-regular"
      color="accent"
      mat-raised-button
    >
      {{ 'IOT_DICTIONARY.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
